import React, { Component } from 'react'
import { connect } from 'react-redux'

import Icon from '../../../elements/icon'
import { GeneralIcons } from '../../../elements/icons'

import './shortcutbar.scss'
class ShortCutBar extends Component {

  constructor (props) {
    super(props)
    this.state = {

    }
  }

  render () {
    if (this.props.overlaysLength > 0) return null

    let orientationClass = this.props.horizontal ? ' horizontal' : ' vertical'
    return (
      <div className={'layout__shortcuts' + orientationClass}>
        <div className='content'>
          {this.props.children}
          <div className='shortcut1'>
            <Icon size='l' icon={null} />
          </div>
          <div className='shortcut2'>
            <Icon size='l' icon={null} />
          </div>
          <div className='shortcut3'>
            <Icon size='l' icon={null} />
          </div>
          <div className='logo'>
            <Icon size='m' icon={GeneralIcons.Apromas_Logo} />
          </div>
        </div>
      </div>
    )
  }

}

ShortCutBar.contextTypes = {
  router: React.PropTypes.object.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    overlaysLength: state.common.overlays.length
  }
}

export default connect(mapStateToProps, {

})(ShortCutBar)



// WEBPACK FOOTER //
// ./src/app/shared/components/Layout/ShortCutBar/index.js